export const LISTENER_WHATSAPP_CHANNEL_BY_ID_COMPANY = "LISTENER_WHATSAPP_CHANNEL_BY_ID_COMPANY"
export const LISTENER_WHATSAPP_CHANNEL_BY_ID_COMPANY_SUCCESS = "LISTENER_WHATSAPP_CHANNEL_BY_ID_COMPANY_SUCCESS"

export const WHATSAPP_CHANNEL_ERROR = "FIND_OR_EDIT_WHATSAPP_CHANNEL_ERROR"
